import React from "react";

// Swappable gray placeholder. Replace with a real <img src={...}/> later.
export const Placeholder = ({ label, className = "", style = {}, ...rest }) => (
  <div className={`ph ${className}`} style={style} {...rest}>
    {label}
  </div>
);

export default Placeholder;
